module.exports = "/images/logo-light-text.png?374d0f2228cd67009c57556dab61a463";